import { App as AntApp, ConfigProvider } from 'antd';
import { useEffect, Suspense, useState, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LoadingApp } from '@/components';
import { useLocaleStore } from './store';
import { setDefaults } from './utils/appConfirm';
import { Routes as AppRoutes } from './routes/routes';
import { useAppContext, useUniversityContext, useUserContext } from './context';
import DevTool from './components/common/DevTool';
import PaymentPage from './components/core/PaymentPage';
import { initSentry } from './utils';
import AuthTimeout from './components/AuthTimeout';
import { envConfig } from './configs';
const MainPage = lazy(() => import('./components/MainPage'));
const LoginPage = lazy(() => import('./components/core/LoginPage'));
const LoginCasFallback = lazy(() => import('./components/core/LoginPage/LoginCasFallback'));

if (envConfig.isCloud) {
  initSentry();
}

setDefaults({
  okText: 'بله',
  cancelText: 'انصراف',
  direction: 'rtl',
  style: { direction: 'rtl', textAlign: 'right' },
});

if (window.localStorage.getItem('debug') === 'true') {
  console.log('envConfig:', envConfig);
}

function App() {

  const pathname = window.location.pathname;
  const { theme } = useAppContext();
  const [loading, setLoading] = useState(true);
  const localeLoading = useLocaleStore(state => state.loading);
  const { loading: profileLoading, isAuth } = useUserContext();
  const { loading: universityLoading, university } = useUniversityContext();
  const [dir, antLocale, fontFamily] = useLocaleStore(state => [state.dir, state.antLocale, state.fontFamily]);

  const loadingApp = <LoadingApp />;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, []);

  if (
    localeLoading ||
    (loading || universityLoading) ||
    (profileLoading && pathname !== AppRoutes.Login)
  ) return loadingApp;

  return (
    <ConfigProvider
      direction={dir}
      locale={antLocale}
      theme={theme}
    >
      <BrowserRouter>
        <AntApp
          style={{
            '--app-font-sans': fontFamily
          } as any}>
          <Suspense fallback={loadingApp || localeLoading}>
            <DevTool />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/loginCas/:accessToken/:refreshToken" element={<LoginCasFallback />} />
              <Route path="/payment-result" element={<PaymentPage />} />
              <Route path="*" element={<MainPage />} />
            </Routes>
          </Suspense>
          {(isAuth && !Number.isNaN(university.autoLogoutTime) && university.autoLogoutTime !== -1) &&
            <AuthTimeout />
          }
        </AntApp>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
